'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleClosedWelcomeMessage = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleClosedWelcomeMessage = exports.handleClosedWelcomeMessage = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.CLOSED_WELCOME_MESSAGE);


//////////////////
// WEBPACK FOOTER
// ./js/post-message/actions/handleClosedWelcomeMessage.js
// module id = 1295
// module chunks = 3